export default __webpack_public_path__ + "static/media/cam.973a5dac.svg";